import React from "react";
import { cls } from "@wss/cls";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import TileContainer from "../../shared/components/TileContainer";
import PlusLogo from "~/common/components/icon/PlusLogo";
import ChildOrNull from "~/common/ChildOrNull";
interface QuantityProps {
  lowestUnitOfMeasurement: string;
  price: number;
  link: string;
  itemNumber: string;
  currentSelectedItemNumber: string;
  quantityPerPackaging: number;
  variationText: string;
  isPlusEligible: boolean;
  setActiveItemNumber: React.Dispatch<React.SetStateAction<string>>;
  analyticsClickTracking?: (trackingLink: string, trackingText: string) => void;
  seoLink?: string;
}
const Quantity = ({
  link,
  price,
  itemNumber,
  currentSelectedItemNumber,
  quantityPerPackaging,
  variationText,
  lowestUnitOfMeasurement,
  isPlusEligible,
  setActiveItemNumber,
  analyticsClickTracking,
  seoLink = ""
}: QuantityProps) => {
  const isCurrentlySelected = itemNumber === currentSelectedItemNumber;
  return <TileContainer link={link} isCurrentlySelected={isCurrentlySelected} isPlusEligible={isPlusEligible} onMouseOver={() => setActiveItemNumber(itemNumber)} onFocus={() => setActiveItemNumber(itemNumber)} onMouseOut={() => setActiveItemNumber(currentSelectedItemNumber)} onBlur={() => setActiveItemNumber(currentSelectedItemNumber)} onClick={() => {
    if (analyticsClickTracking) {
      analyticsClickTracking(seoLink, variationText);
    }
  }} data-sentry-element="TileContainer" data-sentry-component="Quantity" data-sentry-source-file="index.tsx">
      <div className="flex px-2 pt-[7px] pb-1.5 items-center bg-gray-100" data-testid="variation-text">
        <p className="text-sm font-bold text-gray-800 leading-none p-0 m-0">
          {variationText}
        </p>
      </div>
      <div className="flex flex-wrap h-full items-start pb-1.5 pl-2">
        <span className="text-red-600 text-lg leading-none font-bold mt-1.5 mr-2" data-testid="variation-tile-price">
          {formatAsCurrency.formatIfUndefined(price)}
        </span>
        <ChildOrNull condition={!!quantityPerPackaging} data-sentry-element="ChildOrNull" data-sentry-source-file="index.tsx">
          <span className="p-0 m-0 text-[11px] leading-[14px] text-gray-600" data-testid="variation-tile-priceperpackaging">
            {`${formatAsCurrency.formatIfUndefined(quantityPerPackaging)}/${lowestUnitOfMeasurement}`}
          </span>
        </ChildOrNull>
        <ChildOrNull condition={isPlusEligible} data-sentry-element="ChildOrNull" data-sentry-source-file="index.tsx">
          <span className="ml-auto mt-auto -mb-[8px] -mr-[3px]">
            <PlusLogo width={33} height="100%" aria-label="Ships free with Plus" data-testid="variation-tile-plus-flag" data-sentry-element="PlusLogo" data-sentry-source-file="index.tsx" />
          </span>
        </ChildOrNull>
      </div>
    </TileContainer>;
};
export default Quantity;